// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"106":"cadastro","194":"auth-handler","463":"videos"}[chunkId] + "." + {"106":"36a6d969","194":"6f65aea6","463":"711a2928"}[chunkId] + ".css";
};